module.exports = [{
      plugin: require('../node_modules/@sbi-international/boutik.gatsby.plugin.multilocale/dist/gatsby-browser.js'),
      options: {"plugins":[],"skipImplicitWrapRoot":true,"skipImplicitWrapPage":true},
    },{
      plugin: require('../node_modules/@sbi-international/boutik.gatsby.plugin.components/dist/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"name","short_name":"short_name","start_url":"/ca/fr","background_color":"#d65e2a","display":"standalone","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"767aa897d7bfff5fbed1c40605027c5c","lang":"fr-CA","description":"description","localize":[{"lang":"en-CA","start_url":"/ca/en","name":"name","short_name":"short_name","description":"description"},{"lang":"en-US","start_url":"/us/en","name":"name","short_name":"short_name","description":"description"}]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
